import { FC, useContext } from "react";
import appStyles from "../../../App.module.css";
import { PortuguesePurchasePathContext } from "../../PortuguesePurchasePath";
import { IPortugueseInitialQuoteData, IPortuguesePurchasePathContext } from "../../config/interface";

import { formatAmount } from "../../../app-constants";
import { portugueseCustomDescriptions } from "../../config/portuguese-Constant";
import PPPackageDisplayName from "./PPPPackageDisplayName";
type PPPackageSelectorProps = {
  pkg: any;
};
const PPPackageSelector: FC<PPPackageSelectorProps> = (props: PPPackageSelectorProps) => {
  const { pkg } = props;

  const { quoteData, setQuoteData, packages } = useContext(
    PortuguesePurchasePathContext
  ) as IPortuguesePurchasePathContext;

  const onCBValueChange = (event: any) => {
    const _quoteData: IPortugueseInitialQuoteData = { ...quoteData };
    if (event.target.checked) {
      _quoteData.packages = null;
      _quoteData.packages = pkg || {};
    } else {
      const otherPkg: any = packages.find((_pkg: any) => _pkg.alias !== _quoteData.packages.alias);
      _quoteData.packages = otherPkg;
    }
    setQuoteData(_quoteData);
  };

  return pkg ? (
    <div
      className={`${appStyles.collapseBlock} ${
        quoteData?.packages.alias === pkg.alias && packages?.length > 1 ? appStyles.collapseBlockPackageAdded : ""
      }`}
    >
      <div className={appStyles.collapseHeader}>
        <div className={appStyles.collapseHeaderTitle}>
          <p>
            <PPPackageDisplayName packageName={pkg?.name} />
            &nbsp;
            <br />
            {quoteData?.pkgAmounts?.length > 0 &&
              (() => {
                const foundPackage = quoteData.pkgAmounts.find((_pkgAmt) => _pkgAmt.name === pkg?.name);
                return foundPackage
                  ? formatAmount(foundPackage.amount, "US", quoteData.currency?.value || "EUR")
                  : null;
              })()}
            &nbsp;<small>(excl. taxes)</small>
          </p>
        </div>

        {packages?.length > 1 ? (
          <div className={appStyles.collapseHeaderPrice}>
            <h6>
              <div className={appStyles.switchWrapper}>
                <input
                  type="checkbox"
                  value={pkg?.alias}
                  checked={quoteData?.packages.alias === pkg.alias ? true : false}
                  onChange={onCBValueChange}
                  disabled={packages.length === 1 ? true : false}
                />
                <span className={`${appStyles.switchLabel} ${appStyles.p0}`}></span>
              </div>
            </h6>
          </div>
        ) : null}
      </div>

      <div className={appStyles.collapseBody}>
        <h6>
          {pkg.alias === "base_and_optional_package" && (
            <>
              All the <b>Base Package</b> benefits plus:
            </>
          )}
          <ul>
            {Object.entries(portugueseCustomDescriptions[pkg.alias]).map(([key, value]: any) => (
              <li key={key}>
                <strong>{key}:</strong> {value}
              </li>
            ))}
          </ul>
        </h6>
      </div>
    </div>
  ) : null;
};

export default PPPackageSelector;
